export default __webpack_public_path__ + "static/media/r4_polearm_favonius_lance.e0d89f9a.png";